var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container platform-config-page" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("配置管理")]),
              _c("el-breadcrumb-item", [_vm._v("工单类型")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("工单类型")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "index", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    }
                  }
                ])
              }),
              _c(
                "el-table-column",
                { attrs: { prop: "svr_item", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("服务项")]),
                    _c("div", [_vm._v("svr_item")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "all_tp", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("all_tp")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "tp1", align: "center", width: "100" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("tp1")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "tp2", align: "center", width: "100" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("tp2")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "tp3", align: "center", width: "100" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("tp3")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "tp4", align: "center", width: "100" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("tp4")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }